import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { persistor, store } from './Redux/store';
import { Provider } from 'react-redux';
import AppRoute from './AppRoute';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import initialiseInterceptor from './services/interceptor';
import { PersistGate } from 'redux-persist/integration/react';
initialiseInterceptor();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ToastContainer />
            <AppRoute />
        </PersistGate>
    </Provider>,

    document.getElementById('root'),
);
